import common from '../common'

export default {
    list(params) {
        return common.get('/rocheManage/sys/dictItem/list',params);
    },

    add(params) {
        return common.post('/rocheManage/sys/dictItem/add',params);
    },

    edit(params) {
        return common.put('/rocheManage/sys/dictItem/edit',params);
    },

    delete(params) {
        return common.delete('/rocheManage/sys/dictItem/delete',params);
    },
}


// WEBPACK FOOTER //
// ./src/api/sysmanagement/dictitem.js